module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login_box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "centerCon"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), _c('el-form', {
    ref: "ruleForm2",
    staticClass: "login_form_box fl",
    staticStyle: {
      "padding": "10px 40px"
    },
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "form_mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.ruleForm2.form_mobile),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "form_mobile", $$v)
      },
      expression: "ruleForm2.form_mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "sms_code"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "请输入短信验证码"
    },
    model: {
      value: (_vm.ruleForm2.sms_code),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "sms_code", $$v)
      },
      expression: "ruleForm2.sms_code"
    }
  }, [_c('template', {
    slot: "append"
  }, [(_vm.sendMobileCode) ? _c('el-button', {
    on: {
      "click": _vm.sendMobile
    }
  }, [_vm._v("获取短信验证码")]) : _vm._e(), _vm._v(" "), (!_vm.sendMobileCode) ? _c('el-button', [_vm._v(_vm._s(_vm.limit_time) + "秒后重新发送验证码")]) : _vm._e()], 1)], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "new-password",
      "placeholder": "设置8-20位字符,包含字母和数字"
    },
    model: {
      value: (_vm.ruleForm2.password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "password", $$v)
      },
      expression: "ruleForm2.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "re_password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "new-password",
      "placeholder": "确认密码,8-20位字符,包含字母和数字"
    },
    model: {
      value: (_vm.ruleForm2.re_password),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "re_password", $$v)
      },
      expression: "ruleForm2.re_password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "FF7",
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm2')
      }
    }
  }, [_vm._v("\n                            确认注册\n                        ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "rule_checked"
    }
  }, [_c('span', {
    staticClass: "link_btn fl"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.ruleForm2.rule_checked),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "rule_checked", $$v)
      },
      expression: "ruleForm2.rule_checked"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#9b9b9b"
    }
  }, [_vm._v("已阅读并同意")]), _vm._v(" "), (_vm.helpList.length == 0) ? _c('span', [_vm._v("《用户使用协议》")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.helpList), function(item, index) {
    return (_vm.helpList.length > 0) ? _c('span', {
      key: index
    }, [(index > 0) ? _c('span', [_vm._v("及")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "link_btn ",
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "href": item.help_url,
        "target": "_blank"
      }
    }, [_vm._v("《" + _vm._s(item.help_title) + "》")])]) : _vm._e()
  })], 2)]), _vm._v(" "), _c('el-form-item', [_c('router-link', {
    staticClass: "link_btn fl",
    attrs: {
      "to": "/login"
    }
  }, [_c('i', {
    staticClass: "el-icon-back"
  }), _vm._v("已有账号，立即登录")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "login-footer",
    domProps: {
      "innerHTML": _vm._s(_vm.copyRight)
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "run_title"
  }, [_c('img', {
    staticStyle: {
      "height": "40px",
      "margin": "10px 0"
    },
    attrs: {
      "src": require("../../assets/login/logo-across.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/login/login_bg.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginCon"
  }, [_c('div', {
    staticStyle: {
      "text-align": "left",
      "font-size": "16px",
      "padding": "10px 40px"
    }
  }, [_vm._v("用户注册")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38efdeb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/login/register.vue
// module id = 3500
// module chunks = 103